<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-overlay :show="loading">
          <ReceivedEmailsFilter />
        </b-overlay>
        <ReceivedEmailsRow
          v-for="item in receivedEmails"
          :item="item.source"
          :key="item.id"
        />
        <div v-if="!loading && receivedEmails.length === 0" class="text-center py-5">
          <feather-icon icon="InboxIcon" size="48" class="text-muted mb-2" />
          <p class="text-muted">No se encontraron correos recibidos</p>
        </div>
        <b-overlay :show="loading">
          <ReceivedEmailsPagination />
        </b-overlay>
      </div>
    </div>
    <ReceivedEmailViewer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ReceivedEmailsFilter from '../../components/receivedEmails/ReceivedEmailsFilter';
import ReceivedEmailsRow from '../../components/receivedEmails/ReceivedEmailsRow';
import ReceivedEmailsPagination from '../../components/receivedEmails/ReceivedEmailsPagination';
import ReceivedEmailViewer from '../../components/receivedEmails/ReceivedEmailViewer';

export default {
  name: 'ReceivedEmailsList',
  components: {
    ReceivedEmailsFilter,
    ReceivedEmailsRow,
    ReceivedEmailsPagination,
    ReceivedEmailViewer
  },
  computed: {
    ...mapGetters('ReceivedEmails', ['loading', 'receivedEmails'])
  }
};
</script>
